<template>
  <el-main v-if="!showEdit">
    <ul class="menu">
      <li class="item" @click="toCreateResume()">
        <img :src="require('~/assets/images/plus.png')" width="42" alt="新建简历" title="新建简历">
        <div class="con">
          <p class="title">新建简历</p>
          <p class="msg">新建一份简历</p>
        </div>
        <i class="el-icon-arrow-right"></i>
      </li>
      <el-divider></el-divider>
      <li class="item">
        <el-upload :action="action" :show-file-list="false" :before-upload="uploadFile"
          accept="text/html, text/plain, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document">
          <img :src="require('~/assets/images/import.png')" width="42" alt="导入简历" title="导入简历">
          <div class="con">
            <p class="title">导入简历</p>
            <p class="msg">导入现有简历</p>
          </div>
          <i class="el-icon-arrow-right"></i>
        </el-upload>
      </li>
    </ul>
  </el-main>
  <el-container v-else class="main-content">
    <el-aside class="left-panel" width="340px">
      <resumeHelperCard></resumeHelperCard>
      <proResumeCard></proResumeCard>
    </el-aside>
    <el-main class="right-panel">
      <ResumeEditor ref="resumeEditor" :resumeDom="resumeDom" @complete="onSaveComplete"></ResumeEditor>
    </el-main>
    <div class="fixBar">
      <div style="margin: 0 auto; width: 1160px;text-align:right">
      <el-button type="primary" :loading="saving" @click="onSave">立即保存</el-button>
      </div>
    </div>
  </el-container>
</template>

<script>
  import {
    uploadResumeFile, getResumeInfo
  } from '~/api/resume';
  import ResumeEditor from '~/components/ResumeEditor';
  import resumeHelperCard from '~/components/resumeHelperCard';
  import proResumeCard from '~/components/ProResumeCard';
  export default {
    components: {
      ResumeEditor,
      proResumeCard,
      resumeHelperCard
    },
    data() {
      return {
        isNew: this.$route.query.new,
        // eslint-disable-next-line no-undef
        action: process.env.BASE_API + '/Upload/Index',
        showEdit: false,
        resumeDom: {},
        saving: false,       
      };
    },
    created() {
    },
    mounted(){
      if(this.isNew){
        this.showEdit = true;
        this.getResumeDom();
      }
    },
    methods: {
      toCreateResume() {
        this.$router.push({path :'/ResumeNew', query: {new: true}});
        // this.showEdit = true;
      },

      getResumeDom(){
        getResumeInfo().then( m => {
          if(m.errcode === 0){
            this.resumeDom = m.data;
          }
        });
      },

      //上传简历文件
      uploadFile(file) {
        var formData = new FormData();
        formData.append('name', file.name);
        formData.append('file', file);
        uploadResumeFile(formData).then(m => {
          if (m.errcode == 0) {
            this.showEdit = true;
            this.resumeDom = m.data;
          }
        });
      },

      onSave(){
        this.saving = true;
        this.$refs.resumeEditor.Edit();
      },

      onSaveComplete(resumeId){
        this.saving = false;
        if(resumeId){
          this.$router.push('/ResumeIndex?id=' + resumeId );
        }
      }
    }
  };
</script>

<style scoped>
  .el-divider--horizontal {
    margin: 4px 0;
  }

  .fixBar {
    background-color: #fff;
    width: 100%;
    padding: 20px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    -webkit-box-shadow: 0 -2px 12px 0 hsla(0, 0%, 87.8%, .5);
    box-shadow: 0 -2px 12px 0 hsla(0, 0%, 87.8%, .5);
    text-align: center;
  }
</style>